import { Excalidraw } from "@excalidraw/excalidraw";

import "./index.scss";

export default function ExcalidrawApp() {
  return <Excalidraw />;
}
